<div class="small-loading-dialog">
  <mat-spinner diameter="32"></mat-spinner>
  <div class="message">{{ message }}</div>
</div>
